module.exports = __webpack_public_path__ + "static/img/partner-jmj.e054cce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-jmj.png
// module id = c76L
// module chunks = 34